module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_3009.43097662.png";